import React from 'react';
import { Facebook } from 'lucide-react';
import { FaYoutube, FaInstagram } from 'react-icons/fa6';

const SocialSidebar = () => {
    const socialItems = [
        {
            id: 'facebook',
            name: 'Facebook',
            icon: <Facebook size={19} color="#222222" />,
            url: 'https://www.facebook.com/share/1MAvDPPCjZ/'
        },
        {
            id: 'youtube',
            name: 'YouTube',
            icon: <FaYoutube size={20} color="#222222" />,
            url: 'https://m.youtube.com/@MMICommunications'
        },
        {
            id: 'instagram',
            name: 'Instagram',
            icon: <FaInstagram size={19} color="#222222" />,
            url: 'https://www.instagram.com/mmicommunications/'
        }
    ];

    return (
        <>
            <div className="left-social-sidebar">
                {socialItems.map((item) => {
                    return (
                        <div key={item.id} className="social-sidebar-item-wrapper">
                            <a
                                href={item.url}
                                target="_blank"
                                rel="noreferrer"
                                className="social-sidebar-btn"
                                title={item.name}
                                aria-label={item.name}
                            >
                                {item.icon}
                            </a>
                        </div>
                    );
                })}
            </div>

            <style>{`
                .left-social-sidebar {
                    position: fixed;
                    left: 16px;
                    top: 50%;
                    transform: translateY(-50%);
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    z-index: 99999;
                }

                .social-sidebar-item-wrapper {
                    position: relative;
                    display: flex;
                    align-items: center;
                }

                .social-sidebar-btn {
                    width: 44px;
                    height: 44px;
                    border-radius: 12px;
                    background: #ffffff;
                    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
                    border: 1px solid rgba(0, 0, 0, 0.05);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    text-decoration: none;
                    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
                    padding: 0;
                    outline: none;
                }

                .social-sidebar-btn:hover {
                    transform: translateY(-2px) scale(1.06);
                    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.14);
                    background: #ffffff;
                    border-color: rgba(0, 0, 0, 0.1);
                }


                @media (max-width: 768px) {
                    .left-social-sidebar {
                        left: 8px;
                        gap: 6px;
                    }
                    .social-sidebar-btn {
                        width: 38px;
                        height: 38px;
                        border-radius: 10px;
                    }
                }
            `}</style>
        </>
    );
};

export default SocialSidebar;
